export const FallbackBg = () => {
  return (
    <div className="loading-scr">
      <div className="loading-animation">
        <div className="load-bar"></div>
      </div>
    </div>
  );
};
